import { render, staticRenderFns } from "./DeliveryCreate.vue?vue&type=template&id=0ff9ac11&scoped=true"
import script from "./DeliveryCreate.vue?vue&type=script&lang=js"
export * from "./DeliveryCreate.vue?vue&type=script&lang=js"
import style0 from "./DeliveryCreate.vue?vue&type=style&index=0&id=0ff9ac11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff9ac11",
  null
  
)

export default component.exports